import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface RequestAccessResponse {
	status: string;
	requestedAt: number | null;
	alreadyRequested: boolean;
	emailSent: boolean;
}

@Injectable({ providedIn: 'root' })
export class AccessRequestsService {
	constructor(private readonly http: HttpClient) {}

	requestAccess(): Observable<RequestAccessResponse> {
		return this.http.post<RequestAccessResponse>(
			`${environment.api.baseUrl}/v1/access-requests`,
			null
		);
	}
}
